// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cORY","name":"styles_name__R8XWb","phone":"styles_phone__32gXu"};